import React from 'react';
import { AttendanceManagement } from './list';

const AllUsersAttendancePage: React.FC = () => {
  return (
    <AttendanceManagement
      showTabs={false}
      initialTab="shared_projects"
      defaultViewMode="matrix"
      allowProjectExport
      hideListActions
      requireProjectAssignment
      // HR reads attendance here; approving, changing a status and marking a
      // day that was never marked all stay with the reporting line.
      readOnly
      mapViewPermission={{ resource: "Human Resource", action: "user_attendance_map_view" }}
    />
  );
};

export default AllUsersAttendancePage;
